import { LoadingScreenManager } from '@inc/LoadingScreenManager';

export class HomePage {
  constructor() {
    // ローディング画面
    this.loading = new LoadingScreenManager({
      className: '.c-loading-screen',
      logoClassName: '.c-loading-screen__logo',
      screenFadeOutDuration: '0.7s',
      logoFadeInDuration: '0.7s',
      logoFadeOutDuration: '0.5s',
      logoFadeInPauseDuration: '.8s',
      logoFadeOutPauseDuration: '.1s',
      developmentMode: false
    });
  }
}
